import { default as FNS } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

/**
 * "Töö elukaar": append-only event log per query/job, keyed by query id.
 * Read-only on the frontend; the backend has no edit/delete endpoints.
 */
export const fetchJobEvents = createAsyncThunk('jobEvents/fetch', async ({ id }, { dispatch }) => {
  try {
    const events = await FNS.getJobEvents(id);
    dispatch(jobEventsSlice.actions.replaceForQuery({ id, events }));
    return events;
  } catch (e) {
    toast.error(e.message);
  }
});

const jobEventsSlice = createSlice({
  name: 'jobEvents',
  initialState: {},
  reducers: {
    replaceForQuery: (state, { payload: { id, events } }) => {
      state[id] = events || [];
    },
  },
});

export default jobEventsSlice.reducer;
